import { AND, NOT, OR, CLOSE_BRACKET, OPEN_BRACKET } from './constants';

export default class Lexer {
  lex(text) {
    const tokens = [];
    this.text = text;
    this.index = 0;

    while (this.index < this.text.length) {
      const ch = this.text.charAt(this.index);
      if (this.isLogicalOperator(ch)) {
        tokens.push({
          value: ch,
        });

        this.index++;
      } else if (this.isBracket(ch)) {
        tokens.push({
          value: ch,
        });

        this.index++;
      } else if (this.isUnaryOperator(ch)) {
        tokens.push({
          value: ch,
        });
        this.index++;
      } else {
        tokens.push({
          value: this.readText(),
        });
      }
    }
    return tokens;
  }

  isLogicalOperator(ch) {
    return [OR, AND].includes(ch);
  }

  isUnaryOperator(ch) {
    return [NOT].includes(ch);
  }

  isBracket(ch) {
    return [OPEN_BRACKET, CLOSE_BRACKET].includes(ch);
  }

  isText(ch) {
    return (
      !this.isLogicalOperator(ch) &&
      !this.isBracket(ch) &&
      !this.isUnaryOperator(ch)
    );
  }

  readText() {
    let value = '';

    while (this.index < this.text.length) {
      let ch = this.text.charAt(this.index);
      if (this.isText(ch)) {
        value += ch;
        this.index++;
      } else {
        break;
      }
    }

    return value;
  }
}
